import React, { useRef, useState } from "react";
// import PublicBankLayout from "./Bank/Page/PublicBank/Components/PublicBankLayout/PublicBankLayout";
import QRCode from "react-qr-code";
import { RiCustomerService2Fill } from "react-icons/ri";

import ImoIcon from "../../../Assets/ImoIcon.png"
import WhatsppIcon from "../../../Assets/WhatsppIcon.png"
import EmailIcon from "../../../Assets/EmailIcon.png"

import BankInfo from "../../../BankInfo.json"

import { BiSolidPrinter } from "react-icons/bi";
import { FaTurnDown } from "react-icons/fa6";
import PublicBankLayout from "../Components/PublicBankLayout/PublicBankLayout";

interface BankInfo {
  BankLogoSmall: string;
  BankLogoLong: string;
  BankName: string;
  BankAddress: string;
  BorderColor: string;
  BranchName: string;
  RoutingNumber: string;
  SwiftCode: string;
  OfficeNumberOne: string;
  OfficeNumberOneWhatsApp: boolean;
  OfficeNumberOneImo: boolean;
  OfficeNumberTwo?: string;
  OfficeNumberTwoWhatsApp?: boolean;
  OfficeNumberTwoImo?: boolean;
  OfficeEmailOne: string;
  OfficeEmailTwo?: string;
  HotLineNumber: string;
  BankAccountLength: Number;
}


const AccountPrint: React.FC = () => {





  const acTitleRef = useRef<HTMLInputElement>(null);
  const acNoRef = useRef<HTMLInputElement>(null);
  const acMobileNoRef = useRef<HTMLInputElement>(null);

  const printRef = useRef<HTMLDivElement | null>(null);





  // Hover start

  const [PrintHoverOne, setPrintHoverOne] = useState(false);
  const [PrintHoverTwo, setPrintHoverTwo] = useState(false);
  const [PrintHoverThree, sePrintHoverThree] = useState(false);
  const [PrintHoverFour, setPrintHoverFour] = useState(false);
  // Hover End

  const [AcTitle, SetAcTitle] = useState<string>("");
  const [AcNumber, SetAcNumber] = useState<string>("");
  const [AcMobileNumber, SetAcMobileNumber] = useState<string>("");
  const [AccountAllInfo, SetAccountAllInfo] = useState<string>("");




  const [ACLengthValadation, SetACLengthValadation] = useState<string>("");
  const [ACNameLengthValadation, SetACNameLengthValadation] = useState<string>("");
  const [NumberLengthValadation, SetNumberLengthValadation] = useState<string>("");


  const handleSubmit = () => {
    const AC_Title_Input = acTitleRef.current?.value || "";
    const AC_No_Input = acNoRef.current?.value || "";
    const AC_Mobile_No_Input = acMobileNoRef.current?.value || "";

    const ACLengthRequerd = Number(BankInfo?.BankAccountLength) || 13; // Ensure it's a number, fallback to 0 if undefined
    const ACLengthA = ACLengthRequerd - 1;
    const ACLengthB = ACLengthRequerd + 1;

    const ACLength = Number(AC_No_Input.length);
    const ACNameLength = Number(AC_Title_Input.length);
    const NumberLength = Number(AC_Mobile_No_Input.length);

    if (ACLength > ACLengthA && ACLength < ACLengthB) {
      SetACLengthValadation("")

      if (ACNameLength >= 3) {
        SetACNameLengthValadation("")

        if (NumberLength > 10 && NumberLength < 12) {
          SetNumberLengthValadation("")

          SetAcTitle(AC_Title_Input);
          SetAcNumber(AC_No_Input);
          SetAcMobileNumber(AC_Mobile_No_Input);

          SetAccountAllInfo(
            `${BankInfo?.BankName}, Branch Name: ${BankInfo?.BranchName}, AC No: ${AC_No_Input}, AC Name: ${AC_Title_Input},  Routing Number: ${BankInfo?.RoutingNumber}.`
          );

        } else {
          SetNumberLengthValadation(`The number must be 11 digits, as per BD standards.`);
          SetAcTitle("");
          SetAcNumber("");
          SetAcMobileNumber("");
          SetAccountAllInfo("");
        }

      } else {
        SetACNameLengthValadation(`A valid account name requires at least 3 characters.`);
        SetAcTitle("");
        SetAcNumber("");
        SetAcMobileNumber("");
        SetAccountAllInfo("");

      }





    } else {
      SetACLengthValadation(`Ensure the bank account number contains   ${BankInfo?.BankAccountLength} digits.`);
      SetAcTitle("");
      SetAcNumber("");
      SetAcMobileNumber("");
      SetAccountAllInfo("");
    }



  };





  const [activeSection, setActiveSection] = useState<number>(1);

  const renderSection = () => {
    if (activeSection === 1) {
      {/* ================================= Template 1 start ============================== */ }
      return (
        <div ref={printRef} className="">

          <div className="rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>
            <div style={{ display: "flex" }}>
              <div className="" style={{ width: "65%" }}>
                <img src={BankInfo.BankLogoLong ?? undefined} style={{ width: "100%", height: "65px" }} alt="Bank Asia" className="rounded img-fluid" />
              </div>
              <div className="" style={{ width: "35%", borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "5px", paddingLeft: "5px" }}>

                <h6 className="mb-0"><strong style={{ fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}> {BankInfo.BankName}</strong> </h6>

                <span>{BankInfo.BankAddress}</span>
              </div>
            </div>
            <h6 className="mt-2 text-center"><strong> Account Information </strong></h6>
            <table className="table table-bordered rounded text-left  mb-0 table-bordered">
              <tbody className="thead-dark">
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                  <td style={{ padding: "2px 0px 2px 10px", }}><strong>Account Name</strong></td>
                  <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcTitle}</td>
                </tr>
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                  <td style={{ padding: "2px 0px 2px 10px" }}><strong>Account Number</strong></td>
                  <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcNumber}</td>
                </tr>
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                  <td style={{ padding: "2px 0px 2px 10px" }}><strong>Account Mobile No</strong></td>
                  <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcMobileNumber}</td>
                </tr>
              </tbody>
            </table>




            <div style={{ display: "flex", marginTop: "5px" }}>

              <div style={{ width: "45%", padding: "5px", textAlign: "center", }} className="">
                <p style={{ fontSize: "14px", lineHeight: "13px", textAlign: "center", marginBottom: "0px" }}>Scan For Account <br /> Information</p>

                <div style={{ height: "auto", width: "35%", marginTop: "5px", justifySelf: "center" }}>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={AccountAllInfo}
                    viewBox="0 0 256 256"
                  />
                </div>

                <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                  Looking for a quick bank account information print service? Contact +8801934544352
                </p>
              </div>



              <div style={{ width: "55%", padding: "5px", paddingLeft: "10px", borderLeft: `0.1px solid ${BankInfo?.BorderColor}` }} className="">

                <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "8px" }}>
                  <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                  <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                  <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                </p>

                <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "0px" }}>

                  <strong>Office Contact: </strong>
                  <span>
                    {BankInfo.OfficeNumberOneWhatsApp && (
                      <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOneImo && (
                      <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOne}<br />
                  </span>

                  {BankInfo.OfficeNumberTwo && (
                    <span style={{ paddingLeft: "106px", }}>
                      {BankInfo.OfficeNumberTwoWhatsApp && (
                        <>
                          <span>

                            <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>

                        </>
                      )}
                      {BankInfo.OfficeNumberTwoImo && (
                        <>
                          <span>
                            <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>
                        </>
                      )}


                      {BankInfo.OfficeNumberTwo}<br />
                    </span>
                  )}








                  <strong>Email: </strong>
                  <span>
                    <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailOne}
                  </span>


                  {BankInfo.OfficeEmailTwo && (
                    <>
                      <br />
                      <span style={{ paddingLeft: "44px", }}>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                      </span>
                    </>
                  )}



                </p>
                <h5 style={{ textAlign: "center", fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>

              </div>

            </div>


          </div>
        </div>
      );
      {/* ================================= Template 1 end ============================== */ }
    } else if (activeSection === 2) {
      {/* ================================= Template 2 start ============================== */ }
      return (
        <div ref={printRef} className="" >


          <div className=" p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>

            <img src={BankInfo?.BankLogoLong ?? undefined} style={{ width: "100%", height: "85px" }} alt="Bank Asia" className="rounded img-fluid" />

            <h2 className="mb-0" style={{ fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}>{BankInfo.BankName}</h2>

            <small>{BankInfo.BankAddress}</small>

            <div className="d-flex">


              <div style={{ width: "70%" }}>
                <h6 className="text-center"><strong> Account Information </strong></h6>

                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor || '#000'}`,
                  marginTop: "8px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "98%"
                }}>
                  <strong>AC Name: {AcTitle}</strong>
                </div>
                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor}`,
                  marginTop: "8px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "98%"
                }}>
                  <strong>AC Number: {AcNumber}</strong>
                </div>
                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor}`,
                  marginTop: "8px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "98%"
                }}>
                  <strong>Mobile Number: {AcMobileNumber}</strong>
                </div>

                <p style={{ fontSize: "12px", lineHeight: "18px", marginTop: "5px", marginBottom: "5px" }}>
                  <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                  <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                  <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                </p>

                <p style={{ fontSize: "12px", lineHeight: "18px", marginBottom: "0px" }}>
                  <strong>Office Contact: </strong>
                  <span>
                    {BankInfo.OfficeNumberOneWhatsApp && (
                      <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOneImo && (
                      <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOne}<br />
                  </span>


                  {BankInfo?.OfficeNumberTwo && (
                    <span style={{ paddingLeft: "92px", }}>
                      {BankInfo.OfficeNumberTwoWhatsApp && (
                        <>
                          <span>

                            <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>

                        </>
                      )}
                      {BankInfo.OfficeNumberTwoImo && (
                        <>
                          <span>
                            <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>
                        </>
                      )}
                      {BankInfo.OfficeNumberTwo}<br />
                    </span>
                  )}



                  <strong>Email: </strong>
                  <span>
                    <img src={EmailIcon} style={{ width: "12px" }} alt="" /> {BankInfo.OfficeEmailOne}
                  </span>


                  {BankInfo?.OfficeEmailTwo && (
                    <>
                      <br />
                      <span style={{ paddingLeft: "38px", }}>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                      </span>
                    </>
                  )}

                </p>
              </div>


              <div style={{ width: "30%" }}>
                <p style={{ textAlign: "center", marginBottom: "2px" }}>Scan For Account <br /> Information</p>

                <div style={{ height: "auto", maxWidth: "100%", width: "68%", justifySelf: "center" }}>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={AccountAllInfo}
                    viewBox="0 0 256 256"
                  />
                </div>
                <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                  Looking for a quick bank account information print service? Contact +8801934544352
                </p>
                <h5 style={{ textAlign: "center", fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>
              </div>

            </div>



          </div>
        </div>
      );
      {/* ================================= Template 2 end ============================== */ }
    } else if (activeSection === 3) {
      {/* ================================= Template 3 start ==============================  from 2*/ }
      return (
        <div ref={printRef} className=" " >
          <div className="p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>


            <div className="flex" style={{ display: "inline-flex", alignItems: "center", marginBottom: "5px" }}>
              <div>
                <img src={BankInfo?.BankLogoSmall ?? undefined} style={{ width: "150px", height: "120px", }} alt="Bank Asia" className=" img-fluid rounded" />

              </div>
              <div className="" style={{ borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "10px", paddingLeft: "10px" }}>

                <span className="mb-0" style={{ fontSize: "25px", lineHeight: "0", fontWeight: "bold", color: `${BankInfo?.BorderColor}`, }}>{BankInfo.BankName}</span> <br />

                <span >{BankInfo.BankAddress}</span>
              </div>
            </div>


            <div className="d-flex">

              <div style={{ width: "75%" }}>


                <h6 className="text-center"><strong> Account Information </strong></h6>
                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor}`,
                  marginTop: "7px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "95%"
                }}>
                  <strong>AC Name: {AcTitle}</strong>
                </div>
                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor}`,
                  marginTop: "7px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "95%"
                }}>
                  <strong>AC Number: {AcNumber}</strong>
                </div>
                <div className="acname rounded" style={{
                  backgroundColor: "white",
                  border: `1px solid ${BankInfo?.BorderColor}`,
                  marginTop: "7px",
                  padding: "1px",
                  paddingLeft: "5px",
                  width: "95%"
                }}>
                  <strong>Mobile Number: {AcMobileNumber}</strong>
                </div>

                <p style={{ fontSize: "12px", lineHeight: "18px", marginTop: "5px", marginBottom: "0px" }}>
                  <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                  <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                  <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                </p>

                <p style={{ fontSize: "12px", lineHeight: "18px", marginBottom: "0px", marginTop: "5px" }}>
                  <strong>Office Contact: </strong>
                  <span>
                    {BankInfo.OfficeNumberOneWhatsApp && (
                      <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOneImo && (
                      <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOne}<br />
                  </span>


                  {BankInfo?.OfficeNumberTwo && (
                    <span style={{ paddingLeft: "92px", }}>
                      {BankInfo.OfficeNumberTwoWhatsApp && (
                        <>
                          <span>

                            <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>

                        </>
                      )}
                      {BankInfo.OfficeNumberTwoImo && (
                        <>
                          <span>
                            <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>
                        </>
                      )}
                      {BankInfo.OfficeNumberTwo}<br />
                    </span>
                  )}



                  <strong>Email: </strong>
                  <span>
                    <img src={EmailIcon} style={{ width: "12px" }} alt="" /> {BankInfo.OfficeEmailOne}
                  </span>


                  {BankInfo?.OfficeEmailTwo && (
                    <>
                      <br />
                      <span style={{ paddingLeft: "38px", }}>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                      </span>
                    </>
                  )}


                </p>
              </div>



              <div style={{ width: "25%" }}>
                <p style={{ textAlign: "center", marginBottom: "2px", }}>Scan For Account <br /> Information</p>

                <div style={{ height: "auto", maxWidth: "100%", width: "68%", justifySelf: "center" }}>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={AccountAllInfo}
                    viewBox="0 0 256 256"
                  />
                </div>
                <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                  Looking for a quick bank account information print service? Contact +8801934544352
                </p>
                <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>
              </div>

            </div>

          </div>
        </div>
      );
      {/* ================================= Template 3 end ============================== */ }
    } else if (activeSection === 4) {
      {/* ================================= Template 4 start ============================== from 1 */ }
      return (
        <div ref={printRef} className="">
          <div className="p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>


            <div className="flex" style={{ display: "flex", alignItems: "center", }}>

              <div className="banksdfinfo" style={{ width: "75%", }}>

                <span className="mb-0" style={{ fontSize: "35px", lineHeight: "18px", fontWeight: "bold", color: `${BankInfo?.BorderColor}`, }}>{BankInfo.BankName}</span> <br />

                <span>{BankInfo.BankAddress}</span>
              </div>
              <div className="logoff" style={{ width: "20%", borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "5px", paddingLeft: "5px" }}>
                <img src={BankInfo?.BankLogoSmall ?? undefined} style={{ width: "100%", height: "110px", }} alt="Bank Asia" className=" img-fluid rounded" />

              </div>
            </div>


            <h6 className="text-center"><strong> Account Information </strong></h6>
            <table className="table table-bordered rounded text-left  mb-0 table-bordered">
              <tbody className="thead-dark">
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                  <td style={{ padding: "0px 0px 0px 10px", }}><strong>Account Name</strong></td>
                  <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcTitle}</td>
                </tr>
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                  <td style={{ padding: "0px 0px 0px 10px" }}><strong>Account Number</strong></td>
                  <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcNumber}</td>
                </tr>
                <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                  <td style={{ padding: "0px 0px 0px 10px" }}><strong>Account Mobile No</strong></td>
                  <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcMobileNumber}</td>
                </tr>
              </tbody>
            </table>




            <div style={{ display: "flex", marginTop: "5px" }}>

              <div style={{ width: "45%", padding: "5px", textAlign: "center", }} className="">
                <p style={{ fontSize: "14px", lineHeight: "13px", textAlign: "center", marginBottom: "0px" }}>Scan For Account <br /> Information</p>

                <div style={{ height: "auto", width: "35%", marginTop: "5px", justifySelf: "center" }}>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={AccountAllInfo}
                    viewBox="0 0 256 256"
                  />
                </div>

                <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                  Looking for a quick bank account information print service? Contact +8801934544352
                </p>
              </div>



              <div style={{ width: "55%", padding: "5px", paddingLeft: "10px", paddingBottom: "0px", borderLeft: `0.1px solid ${BankInfo?.BorderColor}` }} className="">

                <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "8px" }}>
                  <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                  <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                  <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                </p>

                <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "0px" }}>
                  <strong>Office Contact: </strong>
                  <span>
                    {BankInfo.OfficeNumberOneWhatsApp && (
                      <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOneImo && (
                      <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                    )}&nbsp;
                    {BankInfo.OfficeNumberOne}<br />
                  </span>


                  {BankInfo.OfficeNumberTwo && (
                    <span style={{ paddingLeft: "106px", }}>
                      {BankInfo.OfficeNumberTwoWhatsApp && (
                        <>
                          <span>

                            <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>

                        </>
                      )}
                      {BankInfo.OfficeNumberTwoImo && (
                        <>
                          <span>
                            <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                            &nbsp;
                          </span>
                        </>
                      )}


                      {BankInfo.OfficeNumberTwo}<br />
                    </span>
                  )}



                  <strong>Email: </strong>
                  <span>
                    <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailOne}
                  </span>


                  {BankInfo.OfficeEmailTwo && (
                    <>
                      <br />
                      <span style={{ paddingLeft: "44px", }}>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                      </span>
                    </>
                  )}


                </p>
                <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0px", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>

              </div>

            </div>


          </div>
        </div>
      );
      {/* ================================= Template 4 start ============================== */ }
    }
    return null;
  };

  const handlePrint = () => {
    window.print();
  };



  return (
    <>


      <PublicBankLayout>



        <div className="row">
          {/* Left side start */}
          <div className="col-md-6 pt-2 px-5">

            <div className="card" style={{ backgroundColor: "#f7f7f7", marginBottom: "0px" }}>
              <div className="card-header text-center" style={{ padding: "3px" }}>Generate Account Details Print</div>
              <div className="card-body" style={{ marginTop: "-15px", marginBottom: "5px", paddingBottom: "8px" }}>
                {/* <label>Account Number:</label> */}
                <input ref={acNoRef} style={{ padding: "2px", paddingLeft: "10px", marginTop: "10px" }} className="form-control " type="number" placeholder="Account Number" />
                <p className='text-danger' style={{ marginBottom: "0px" }}>{ACLengthValadation}</p>

                {/* <label className='mt-1'>Account Name:</label> */}
                <input ref={acTitleRef} style={{ padding: "2px", paddingLeft: "10px", marginTop: "10px" }} className="form-control " type="text" placeholder="Account Name" />
                <p className='text-danger' style={{ marginBottom: "0px" }}>{ACNameLengthValadation}</p>


                {/* <label className='mt-1'>Mobile Number:</label> */}
                <input ref={acMobileNoRef} style={{ padding: "2px", paddingLeft: "10px", marginTop: "10px", marginBottom: "8px" }} className="form-control " type="number" placeholder="Mobile Number" />
                <span className='text-danger'>{NumberLengthValadation}</span>


                <div className="d-flex">
                  <button
                    onClick={handleSubmit}
                    className="btn btn-success w-100 mb-0 mt-1 mx-2"

                  >
                    Submit &nbsp;
                    <FaTurnDown />
                  </button>

                  <button
                    onClick={handlePrint}
                    className="btn btn-primary w-100 mb-0 mt-1 mx-2"

                  >
                    Print &nbsp;
                    <BiSolidPrinter />
                  </button>

                </div>


              </div>
            </div>


          </div>
          {/* Left side end */}

          {/* Print Button Section Start  */}
          <div className="col-md-6 pt-2 px-5 mb-2">
            <div className="card" style={{ backgroundColor: "#f7f7f7", marginTop: "2px", paddingBottom: "0px" }}>
              <div className="card-header text-center" style={{ padding: "3px" }}>Select Template for Printing</div>
              <div className="card-body" style={{ marginTop: "-10px", paddingBottom: "0px" }}>

                <button className="btn btn-primary w-100 mb-2 mt-1" style={{
                  backgroundColor: PrintHoverOne
                    ? "#81689D"
                    : activeSection === 1
                      ? "#81689D"
                      : "rgb(71 79 122)",
                  padding: "2px",
                  transition: "700ms",
                }}
                  onMouseEnter={() => setPrintHoverOne(true)}
                  onMouseLeave={() => setPrintHoverOne(false)}
                  onClick={() => setActiveSection(1)}
                >
                  Print Template One (1)
                </button>


                <button className="btn btn-primary w-100 mb-2 mt-1" style={{
                  backgroundColor: PrintHoverTwo
                    ? "#81689D"
                    : activeSection === 2
                      ? "#81689D"
                      : "rgb(71 79 122)",
                  padding: "2px",
                  transition: "700ms",
                }}
                  onMouseEnter={() => setPrintHoverTwo(true)}
                  onMouseLeave={() => setPrintHoverTwo(false)}
                  onClick={() => setActiveSection(2)}
                >
                  Print Template Two (2)
                </button>

                <button className="btn btn-primary w-100 mb-2 mt-1" style={{
                  backgroundColor: PrintHoverThree
                    ? "#81689D"
                    : activeSection === 3
                      ? "#81689D"
                      : "rgb(71 79 122)",
                  padding: "2px",
                  transition: "700ms",
                }}
                  onMouseEnter={() => sePrintHoverThree(true)}
                  onMouseLeave={() => sePrintHoverThree(false)}
                  onClick={() => setActiveSection(3)}
                >
                  Print Template Three (3)
                </button>

                <button className="btn btn-primary w-100 mb-2 mt-1" style={{
                  backgroundColor: PrintHoverFour
                    ? "#81689D"
                    : activeSection === 4
                      ? "#81689D"
                      : "rgb(71 79 122)",
                  padding: "2px",
                  transition: "700ms",
                }}
                  onMouseEnter={() => setPrintHoverFour(true)}
                  onMouseLeave={() => setPrintHoverFour(false)}
                  onClick={() => setActiveSection(4)}
                >
                  Print Template Four (4)
                </button>



              </div>
            </div>

          </div>
          {/* Print Button Section End  */}
        </div>




        {/* ============================= All Templete Start ================================== */}

        <div className="row">

          {/* Left Side Start  */}
          <div className="col-md-6">
            {/* ================================= Template 1 start ============================== */}
            <h3 className="text-center" style={{ color: "#343a40", margin: "0", padding: "0" }}>Templete One (1)</h3>
            <div ref={printRef} className=" pb-2 px-5">

              <div className="p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>
                <div style={{ display: "flex" }}>
                  <div className="" style={{ width: "65%" }}>
                    <img src={BankInfo.BankLogoLong ?? undefined} style={{ width: "100%", height: "65px" }} alt="Bank Asia" className="rounded img-fluid" />
                  </div>
                  <div className="" style={{ width: "35%", borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "5px", paddingLeft: "5px" }}>

                    <h6 className="mb-0"><strong style={{ fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}> {BankInfo.BankName}</strong> </h6>

                    <span>{BankInfo.BankAddress}</span>
                  </div>
                </div>
                <h6 className="mt-2 text-center"><strong> Account Information </strong></h6>
                <table className="table table-bordered rounded text-left  mb-0 table-bordered">
                  <tbody className="thead-dark">
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                      <td style={{ padding: "2px 0px 2px 10px", }}><strong>Account Name</strong></td>
                      <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcTitle}</td>
                    </tr>
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                      <td style={{ padding: "2px 0px 2px 10px" }}><strong>Account Number</strong></td>
                      <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcNumber}</td>
                    </tr>
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px", }}>
                      <td style={{ padding: "2px 0px 2px 10px" }}><strong>Account Mobile No</strong></td>
                      <td style={{ width: "60%", padding: "2px 0px 2px 10px", fontWeight: "bold" }}>{AcMobileNumber}</td>
                    </tr>
                  </tbody>
                </table>




                <div style={{ display: "flex", marginTop: "5px" }}>

                  <div style={{ width: "45%", padding: "5px", textAlign: "center", }} className="">
                    <p style={{ fontSize: "14px", lineHeight: "13px", textAlign: "center", marginBottom: "0px" }}>Scan For Account <br /> Information</p>

                    <div style={{ height: "auto", width: "35%", marginTop: "5px", justifySelf: "center" }}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={AccountAllInfo}
                        viewBox="0 0 256 256"
                      />
                    </div>

                    <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                      Looking for a quick bank account information print service? Contact +8801934544352
                    </p>
                  </div>



                  <div style={{ width: "55%", padding: "5px", paddingLeft: "10px", borderLeft: `0.1px solid ${BankInfo?.BorderColor}` }} className="">

                    <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "8px" }}>
                      <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                      <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                      <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                    </p>

                    <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "0px" }}>

                      <strong>Office Contact: </strong>
                      <span>
                        {BankInfo.OfficeNumberOneWhatsApp && (
                          <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOneImo && (
                          <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOne}<br />
                      </span>

                      {BankInfo.OfficeNumberTwo && (
                        <span style={{ paddingLeft: "106px", }}>
                          {BankInfo.OfficeNumberTwoWhatsApp && (
                            <>
                              <span>

                                <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>

                            </>
                          )}
                          {BankInfo.OfficeNumberTwoImo && (
                            <>
                              <span>
                                <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>
                            </>
                          )}


                          {BankInfo.OfficeNumberTwo}<br />
                        </span>
                      )}








                      <strong>Email: </strong>
                      <span>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailOne}
                      </span>


                      {BankInfo.OfficeEmailTwo && (
                        <>
                          <br />
                          <span style={{ paddingLeft: "44px", }}>
                            <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                          </span>
                        </>
                      )}



                    </p>
                    <h5 style={{ textAlign: "center", fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>

                  </div>

                </div>


              </div>
            </div>
            {/* ================================= Template 1 start ============================== */}



            {/* ================================= Template 2 start ============================== */}
            <h3 className="text-center" style={{ color: "#343a40", margin: "0", padding: "0" }}>Templete Two (2)</h3>
            <div ref={printRef} className=" pb-2 px-5" >


              <div className=" p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>

                <img src={BankInfo?.BankLogoLong ?? undefined} style={{ width: "100%", height: "85px" }} alt="Bank Asia" className="rounded img-fluid" />

                <h2 className="mb-0" style={{ fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}>{BankInfo.BankName}</h2>

                <small>{BankInfo.BankAddress}</small>

                <div className="d-flex">


                  <div style={{ width: "70%" }}>
                    <h6 className="text-center"><strong> Account Information </strong></h6>

                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor || '#000'}`,
                      marginTop: "8px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "98%"
                    }}>
                      <strong>AC Name: {AcTitle}</strong>
                    </div>
                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor}`,
                      marginTop: "8px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "98%"
                    }}>
                      <strong>AC Number: {AcNumber}</strong>
                    </div>
                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor}`,
                      marginTop: "8px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "98%"
                    }}>
                      <strong>Mobile Number: {AcMobileNumber}</strong>
                    </div>

                    <p style={{ fontSize: "12px", lineHeight: "18px", marginTop: "5px", marginBottom: "5px" }}>
                      <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                      <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                      <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                    </p>

                    <p style={{ fontSize: "12px", lineHeight: "18px", marginBottom: "0px" }}>
                      <strong>Office Contact: </strong>
                      <span>
                        {BankInfo.OfficeNumberOneWhatsApp && (
                          <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOneImo && (
                          <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOne}<br />
                      </span>


                      {BankInfo?.OfficeNumberTwo && (
                        <span style={{ paddingLeft: "92px", }}>
                          {BankInfo.OfficeNumberTwoWhatsApp && (
                            <>
                              <span>

                                <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>

                            </>
                          )}
                          {BankInfo.OfficeNumberTwoImo && (
                            <>
                              <span>
                                <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>
                            </>
                          )}
                          {BankInfo.OfficeNumberTwo}<br />
                        </span>
                      )}



                      <strong>Email: </strong>
                      <span>
                        <img src={EmailIcon} style={{ width: "12px" }} alt="" /> {BankInfo.OfficeEmailOne}
                      </span>


                      {BankInfo?.OfficeEmailTwo && (
                        <>
                          <br />
                          <span style={{ paddingLeft: "38px", }}>
                            <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                          </span>
                        </>
                      )}

                    </p>
                  </div>


                  <div style={{ width: "30%" }}>
                    <p style={{ textAlign: "center", marginBottom: "2px" }}>Scan For Account <br /> Information</p>

                    <div style={{ height: "auto", maxWidth: "100%", width: "68%", justifySelf: "center" }}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={AccountAllInfo}
                        viewBox="0 0 256 256"
                      />
                    </div>
                    <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                      Looking for a quick bank account information print service? Contact +8801934544352
                    </p>
                    <h5 style={{ textAlign: "center", fontWeight: "bold", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>
                  </div>

                </div>



              </div>
            </div>
            {/* ================================= Template 2 end ============================== */}
          </div>
          {/* Left Side End  */}








          {/* Right Side Start  */}
          <div className="col-md-6">
            {/* ================================= Template 3 start ==============================  from 2*/}
            <h3 className="text-center" style={{ color: "#343a40", margin: "0", padding: "0" }}>Templete Three (3)</h3>
            <div ref={printRef} className=" pb-2 px-5 " >
              <div className="p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>


                <div className="flex" style={{ display: "inline-flex", alignItems: "center", marginBottom: "5px" }}>
                  <div>
                    <img src={BankInfo?.BankLogoSmall ?? undefined} style={{ width: "150px", height: "120px", }} alt="Bank Asia" className=" img-fluid rounded" />

                  </div>
                  <div className="" style={{ borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "10px", paddingLeft: "10px" }}>

                    <span className="mb-0" style={{ fontSize: "25px", lineHeight: "0", fontWeight: "bold", color: `${BankInfo?.BorderColor}`, }}>{BankInfo.BankName}</span> <br />

                    <span >{BankInfo.BankAddress}</span>
                  </div>
                </div>


                <div className="d-flex">

                  <div style={{ width: "75%" }}>


                    <h6 className="text-center"><strong> Account Information </strong></h6>
                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor}`,
                      marginTop: "7px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "95%"
                    }}>
                      <strong>AC Name: {AcTitle}</strong>
                    </div>
                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor}`,
                      marginTop: "7px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "95%"
                    }}>
                      <strong>AC Number: {AcNumber}</strong>
                    </div>
                    <div className="acname rounded" style={{
                      backgroundColor: "white",
                      border: `1px solid ${BankInfo?.BorderColor}`,
                      marginTop: "7px",
                      padding: "1px",
                      paddingLeft: "5px",
                      width: "95%"
                    }}>
                      <strong>Mobile Number: {AcMobileNumber}</strong>
                    </div>

                    <p style={{ fontSize: "12px", lineHeight: "18px", marginTop: "5px", marginBottom: "0px" }}>
                      <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                      <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                      <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                    </p>

                    <p style={{ fontSize: "12px", lineHeight: "18px", marginBottom: "0px", marginTop: "5px" }}>
                      <strong>Office Contact: </strong>
                      <span>
                        {BankInfo.OfficeNumberOneWhatsApp && (
                          <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOneImo && (
                          <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOne}<br />
                      </span>


                      {BankInfo?.OfficeNumberTwo && (
                        <span style={{ paddingLeft: "92px", }}>
                          {BankInfo.OfficeNumberTwoWhatsApp && (
                            <>
                              <span>

                                <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>

                            </>
                          )}
                          {BankInfo.OfficeNumberTwoImo && (
                            <>
                              <span>
                                <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>
                            </>
                          )}
                          {BankInfo.OfficeNumberTwo}<br />
                        </span>
                      )}



                      <strong>Email: </strong>
                      <span>
                        <img src={EmailIcon} style={{ width: "12px" }} alt="" /> {BankInfo.OfficeEmailOne}
                      </span>


                      {BankInfo?.OfficeEmailTwo && (
                        <>
                          <br />
                          <span style={{ paddingLeft: "38px", }}>
                            <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                          </span>
                        </>
                      )}


                    </p>
                  </div>



                  <div style={{ width: "25%" }}>
                    <p style={{ textAlign: "center", marginBottom: "2px", }}>Scan For Account <br /> Information</p>

                    <div style={{ height: "auto", maxWidth: "100%", width: "68%", justifySelf: "center" }}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={AccountAllInfo}
                        viewBox="0 0 256 256"
                      />
                    </div>
                    <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                      Looking for a quick bank account information print service? Contact +8801934544352
                    </p>
                    <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>
                  </div>

                </div>

              </div>
            </div>
            {/* ================================= Template 3 end ============================== */}



            {/* ================================= Template 4 start ============================== from 1 */}
            <h3 className="text-center" style={{ color: "#343a40", margin: "0", padding: "0" }}>Templete Four (4)</h3>
            <div ref={printRef} className=" pb-2 px-5">
              <div className="p-3 rounded" style={{ width: "100%", backgroundColor: "white", border: `2px solid ${BankInfo?.BorderColor}` }}>


                <div className="flex" style={{ display: "flex", alignItems: "center", }}>

                  <div className="banksdfinfo" style={{ width: "75%", }}>

                    <span className="mb-0" style={{ fontSize: "35px", lineHeight: "18px", fontWeight: "bold", color: `${BankInfo?.BorderColor}`, }}>{BankInfo.BankName}</span> <br />

                    <span>{BankInfo.BankAddress}</span>
                  </div>
                  <div className="logoff" style={{ width: "20%", borderLeft: `0.1px solid ${BankInfo?.BorderColor}`, marginLeft: "5px", paddingLeft: "5px" }}>
                    <img src={BankInfo?.BankLogoSmall ?? undefined} style={{ width: "100%", height: "110px", }} alt="Bank Asia" className=" img-fluid rounded" />

                  </div>
                </div>


                <h6 className="text-center"><strong> Account Information </strong></h6>
                <table className="table table-bordered rounded text-left  mb-0 table-bordered">
                  <tbody className="thead-dark">
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                      <td style={{ padding: "0px 0px 0px 10px", }}><strong>Account Name</strong></td>
                      <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcTitle}</td>
                    </tr>
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                      <td style={{ padding: "0px 0px 0px 10px" }}><strong>Account Number</strong></td>
                      <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcNumber}</td>
                    </tr>
                    <tr className="rounded" style={{ border: `1px solid ${BankInfo?.BorderColor}`, borderRadius: "5px" }}>
                      <td style={{ padding: "0px 0px 0px 10px" }}><strong>Account Mobile No</strong></td>
                      <td style={{ width: "60%", padding: "0px 0px 0px 10px", fontWeight: "bold" }}>{AcMobileNumber}</td>
                    </tr>
                  </tbody>
                </table>




                <div style={{ display: "flex", marginTop: "5px" }}>

                  <div style={{ width: "45%", padding: "5px", textAlign: "center", }} className="">
                    <p style={{ fontSize: "14px", lineHeight: "13px", textAlign: "center", marginBottom: "0px" }}>Scan For Account <br /> Information</p>

                    <div style={{ height: "auto", width: "35%", marginTop: "5px", justifySelf: "center" }}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={AccountAllInfo}
                        viewBox="0 0 256 256"
                      />
                    </div>

                    <p style={{ fontSize: "10px", lineHeight: "12px", textAlign: "center", marginBottom: "0px" }}>
                      Looking for a quick bank account information print service? Contact +8801934544352
                    </p>
                  </div>



                  <div style={{ width: "55%", padding: "5px", paddingLeft: "10px", paddingBottom: "0px", borderLeft: `0.1px solid ${BankInfo?.BorderColor}` }} className="">

                    <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "8px" }}>
                      <strong>Branch Name:</strong> {BankInfo.BranchName} <br />
                      <strong>Routing Number:</strong> {BankInfo.RoutingNumber} <br />
                      <strong>Swift Code:</strong> {BankInfo.SwiftCode} <br />
                    </p>

                    <p style={{ fontSize: "14px", lineHeight: "18px", marginBottom: "0px" }}>
                      <strong>Office Contact: </strong>
                      <span>
                        {BankInfo.OfficeNumberOneWhatsApp && (
                          <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOneImo && (
                          <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                        )}&nbsp;
                        {BankInfo.OfficeNumberOne}<br />
                      </span>


                      {BankInfo.OfficeNumberTwo && (
                        <span style={{ paddingLeft: "106px", }}>
                          {BankInfo.OfficeNumberTwoWhatsApp && (
                            <>
                              <span>

                                <img src={WhatsppIcon} alt="WhatsApp Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>

                            </>
                          )}
                          {BankInfo.OfficeNumberTwoImo && (
                            <>
                              <span>
                                <img src={ImoIcon} alt="Imo Icon" style={{ width: "14px" }} />
                                &nbsp;
                              </span>
                            </>
                          )}


                          {BankInfo.OfficeNumberTwo}<br />
                        </span>
                      )}



                      <strong>Email: </strong>
                      <span>
                        <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailOne}
                      </span>


                      {BankInfo.OfficeEmailTwo && (
                        <>
                          <br />
                          <span style={{ paddingLeft: "44px", }}>
                            <img src={EmailIcon} style={{ width: "14px" }} alt="" /> {BankInfo.OfficeEmailTwo}
                          </span>
                        </>
                      )}


                    </p>
                    <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "0px", color: `${BankInfo?.BorderColor}` }}><RiCustomerService2Fill /> <br /> {BankInfo.HotLineNumber}</h5>

                  </div>

                </div>


              </div>
            </div>
            {/* ================================= Template 4 start ============================== */}
          </div>
          {/* Right Side Start  */}



        </div>
        {/* ============================= All Templete End ================================== */}




      </PublicBankLayout>


      <div className="mt-1" id="print-section">
        {renderSection()}
      </div>

      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #print-section, #print-section * {
              visibility: visible;
            }
            #print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
        `}
      </style>



    </>



  );
};

export default AccountPrint;
